module.exports = __webpack_public_path__ + "img/lotto.87699cba.jpg";